"use client"

import { usePathname } from "next/navigation"
import { useEffect } from "react"
import { captureGclid, captureFbclid, initRouteTracker } from "@/lib/services/tracking-service"
import { ehRotaExternaDoPersonal, rastreamentoBloqueado } from "@/lib/utils/tracking-routes"

export function RouteTracker() {
  const pathname = usePathname()

  // Captura gclid e fbclid na primeira visita (persistem por 90 dias).
  // Pula nas páginas externas do personal, esses click ids são do anúncio
  // dele, não devem entrar na nossa atribuição.
  useEffect(() => {
    if (ehRotaExternaDoPersonal(window.location.pathname)) return
    captureGclid()
    captureFbclid()
  }, [])

  /* Dispara `pagina_vista` a cada mudança de rota (SPA), e só onde a visita é
     do funil: fora ficam as páginas externas do personal (o tráfego é dele), a
     área logada de uso do produto, a porta do aluno e o aparelho com conta de
     aluno aberta. Quem responde tudo isso é `rastreamentoBloqueado`. */
  useEffect(() => {
    if (rastreamentoBloqueado(pathname)) return
    initRouteTracker()
  }, [pathname])

  return null
}
